(function (){
	if ($('.POPUP').length === 0) { return }

	$('.POPUP').addClass('active');
	$('body').addClass('popup-overflow');
	
	$('.POPUP__close').on('click', function() {
		$('.POPUP').removeClass('active');
		$('body').removeClass('popup-overflow');
	});
})();